import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum';

window._gu_env = process.env.STAGE;
window._gu_debug = process.env.STAGE != 'prod';

const initDDRum = () => {
  try {
    datadogRum.init({
      applicationId: process.env.DATADOG_ID,
      clientToken: process.env.DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'client-side',
      // Specify a version number to identify the deployed version of your application in Datadog
      version: '2.0.0',
      env: process.env.STAGE,
      sampleRate: 1,
      trackInteractions: true
    });
  } catch (e) {
    console.log('failed to init ddrum');
  }
}

const initDDLogs = () => {
  try {
    datadogLogs.init({
      clientToken: process.env.DATADOG_LOG_CLIENT_TOKEN,
      site: 'datadoghq.com',
      forwardErrorsToLogs: true,
      sampleRate: 100,
      env: process.env.STAGE
    });
  } catch (e) {
    console.log('failed to init ddlog');
  }
}
initDDLogs();
initDDRum();


const initDDGlobalContext = () => {
  datadogLogs.addLoggerGlobalContext('env', window['_gu_env']);
  datadogLogs.addLoggerGlobalContext('stage', window['_gu_env']);
  datadogLogs.addLoggerGlobalContext('service', 'web');
};
initDDGlobalContext();
datadogLogs.createLogger('giddyup', {
  level: 'debug',
});

const ddlogInstance = datadogLogs.getLogger('giddyup');
window._ddLogger = datadogLogs;
window._ddRum = datadogRum;
const isError = (val) => {
  /* eslint-disable */
  return !!val && typeof val === 'object' && (
    val instanceof Error || (
      val.hasOwnProperty('message') && val.hasOwnProperty('stack')
    )
  );
  /* eslint-enable */
}


const Logger = {
  addGlobalContext: (context) => {
    try {
      const keys = Object.keys(context);
      keys.forEach(key => {
        ddlogInstance.addContext(key, context[key]);
      });
    } catch (e) { console.log(e); }
  },
  getGlobalContext: () => {
    try {
      return datadogLogs.getLoggerGlobalContext();
    } catch (e) { console.log(e); }
  },
  debug: (msg, context = {}) => {
    try {
      context._logLevel = 'debug';
      context.log = {msg};
      context.gu_correlationId = window.gu_correlationId;
      if (window._gu_debug) {
        console.log(context);
      }
      ddlogInstance.debug(context);
    } catch (e) { console.log(e); }
  },
  info: (msg, context = {}) => {
    try {
      context._logLevel = 'info';
      context.log = {msg};
      context.gu_correlationId = window.gu_correlationId;
      if (window._gu_debug) {
        console.log(context);
      }
      ddlogInstance.info(context);
    } catch (e) { console.log(e); }
  },
  warn: (msg, context = {}) => {
    try {
      context._logLevel = 'warn';
      context.log = {msg};
      context.gu_correlationId = window.gu_correlationId;
      if (window._gu_debug) {
        console.log(context);
      }
      ddlogInstance.warn(context);

    } catch (e) { console.log(e); }
  },
  error: (msg, error = null, context = {}) => {
    try {
      context._logLevel = 'error';
      context.gu_correlationId = window.gu_correlationId;
      if (isError(error)) {
        context.error = error;
        context.log = { msg, error: JSON.stringify(error, Object.getOwnPropertyNames(error)) };
        context.log.error_stack = error?.stack;
        context.log.error_message = error?.message;
        context.log.error_type = error?.type;
      }
      if (window._gu_debug) {
        console.log(context);
      }
      ddlogInstance.error(context);
    } catch (e) { console.log(e); }
  },
};
window._guLogger = Logger;

export default Logger;

